import { Box } from "@mui/material";

import { BodyTextSmall } from "~/components/Typographies";
import { productModules } from "~/themes/moduleColors";

interface ProductNameProps {
	fontSize?: string;
	name: string;
}

const ProductName = ({ fontSize = "0.875rem", name }: ProductNameProps) => {
	const upperName = name.toUpperCase();
	const hasTM = productModules.includes(upperName);

	return (
		<Box sx={{ alignItems: "baseline", display: "inline-flex" }}>
			<BodyTextSmall>{upperName}</BodyTextSmall>
			{hasTM && (
				<BodyTextSmall
					component="span"
					sx={{
						fontSize: `calc(${fontSize} * 1.1)`,
						ml: 0.2,
						position: "relative",
						top: `calc(${fontSize} * -0.2)`
					}}
				>
					™
				</BodyTextSmall>
			)}
		</Box>
	);
};

export default ProductName;
